import { Link } from "react-router-dom";

export function Logo({ size = "text-2xl", to = "/" }) {
  return (
    <Link to={to} className={`font-display font-black tracking-tight ${size} select-none`} data-testid="app-logo">
      <span className="text-emerald-400">MoYo Stars</span>
      <span className="text-pink-400"> Date</span>
    </Link>
  );
}
